<template>
  <div class="home">
   <router-link to="/generator">Click Here :D</router-link>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
 
}
</script>
